var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplenishmentOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_3589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1F1F1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_3589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.175 17C16.675 17 16.2917 16.7875 16.025 16.3625C15.7583 15.9375 15.7417 15.5 15.975 15.05L17 13H15C14.45 13 13.9792 12.8042 13.5875 12.4125C13.1958 12.0208 13 11.55 13 11V8C13 7.45 13.1958 6.97917 13.5875 6.5875C13.9792 6.19583 14.45 6 15 6H18C18.55 6 19.0208 6.19583 19.4125 6.5875C19.8042 6.97917 20 7.45 20 8V12.525C20 12.675 19.9875 12.8292 19.9625 12.9875C19.9375 13.1458 19.8833 13.2917 19.8 13.425L18.375 16.25C18.2583 16.4833 18.0917 16.6667 17.875 16.8C17.6583 16.9333 17.425 17 17.175 17ZM8.175 17C7.675 17 7.29167 16.7875 7.025 16.3625C6.75833 15.9375 6.74167 15.5 6.975 15.05L8 13H6C5.45 13 4.97917 12.8042 4.5875 12.4125C4.19583 12.0208 4 11.55 4 11V8C4 7.45 4.19583 6.97917 4.5875 6.5875C4.97917 6.19583 5.45 6 6 6H9C9.55 6 10.0208 6.19583 10.4125 6.5875C10.8042 6.97917 11 7.45 11 8V12.525C11 12.675 10.9875 12.8292 10.9625 12.9875C10.9375 13.1458 10.8833 13.2917 10.8 13.425L9.375 16.25C9.25833 16.4833 9.09167 16.6667 8.875 16.8C8.65833 16.9333 8.425 17 8.175 17Z",
    fill: "#1F1F1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplenishmentOrders);
export default __webpack_public_path__ + "static/media/replenishment-orders.961ccfbbda034c0ee4e56d555566e4cf.svg";
export { ForwardRef as ReactComponent };